
            const data = {"name":"subtract-circle-1","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M256 469c-118 0-213-95-213-213S138 43 256 43s213 95 213 213-95 213-213 213zm0-384c-94 0-171 77-171 171s77 171 171 171 171-77 171-171S350 85 256 85zM149 235h214v42H149z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    